var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-area__col",attrs:{"to":{ name: '報到詳細頁' }}},[_c('router-link',{staticClass:"course-block",attrs:{"to":{
      name: '報到詳細頁',
      params: {
        schedule_time_id: _vm.schedule.schedule_time_id,
        date: _vm.date
      }
    }}},[_c('p',{staticClass:"course-block__time"},[_vm._v(" "+_vm._s(_vm.schedule.start_at)+"-"+_vm._s(_vm.schedule.end_at)+" ")]),_c('p',{staticClass:"course-block__name",style:(("color:" + (_vm.schedule.course.color_code)))},[_vm._v(" "+_vm._s(_vm.schedule.course.name)+" ")]),_c('p',{staticClass:"course-block__teacher"},[_vm._v(_vm._s(_vm.schedule.user.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }